
import { defineComponent } from "vue";
import {loadBankAccountsAPI, updateSelectedBankAccountAPI, saveNewZenithAccountAPI}  from "@/api/encashment";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from 'axios';


export default defineComponent({
  name: "encashmentprocess", 
  data(){
      return { 
        currentlySelected : {},
        zenithaccountsList : {},
        currentlySelectedAccount : '',
        newaccountno: '',
        isShowAddAccountForm : false,
        isSaving : false,
      }
  },
  methods: {
    async loadBankAccounts(){ 
      const response = await loadBankAccountsAPI();
      if(response){
        this.zenithaccountsList = response.data.zenithaccounts;
        this.currentlySelected = response.data.currentlySelected;
 
        this.currentlySelectedAccount = response.data.currentlySelected.accountno;
      }
    },
    async updateSelectedBankAccount(){
      console.log(this.isShowAddAccountForm);
      const response = await updateSelectedBankAccountAPI({accountno: this.currentlySelectedAccount});
      if(response){
        
      }
      this.isShowAddAccountForm = false;
      console.log(this.isShowAddAccountForm);
    },
    showAddAccountForm(){
      if(this.isShowAddAccountForm == true){
        this.isShowAddAccountForm = false;
      } else {
        this.isShowAddAccountForm = true;
      }
    },
    async saveNewZenithAccount(){
      this.isSaving = true;
      const param = {
        accountno : this.newaccountno
      };
      const response = await saveNewZenithAccountAPI(param);

      
      
      if(response.data.result == "SUCCESS"){

        Swal.fire({
          title: "",
          text: response.data.message,
          icon: "success",
          
        }); 
        this.loadBankAccounts();
        this.isShowAddAccountForm = false;
      } else {

        Swal.fire({
          title: "",
          text: response.data.message,
          icon: "error",
          
        }); 
      }
      this.isSaving = false;
    }

  },
  mounted(){
      this.loadBankAccounts();
  },
  components: {},
  props: {
    widgetClasses: String
  }
});
